import { useSelector } from '../dependencies';

import { companiesSelector } from '../services/selectors';

export default function useCompanies() {
    return useSelector(companiesSelector);
}
